import { Card, Icon, Button, Divider, Slider, Spin } from "antd";
import Zillow from "./images/bfile-zillow-zestimates.png";
import { Translate } from "react-translated";
import React, { Component } from "react";
import { AutoComplete } from "antd";
import F from "../../../Functions";
import axios from "axios";
import SliderLayout from "./sliderlayout";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class ZillowSecondaryHomeValueContainer extends Component {
  state = {
    zillow_loading: false,
    dataSource: [],
    addresses: {},
    zpid: null
  };

  componentDidMount = () => {
    if (
      this.props.wizard.secondary_zillow_address &&
      this.props.wizard.secondary_zillow_address !== ""
    ) {
      this.handleSearch(this.props.wizard.secondary_zillow_address);
    }
  };

  zillowChecker = () => {
    if (this.state.zpid) {
      const { updateField } = this.props;

      // get Range Values
      const rangeValues = F.getRangeValues_10M();

      this.setState({ zillow_loading: true });
      axios.get("/api/zestimate-checker/" + this.state.zpid).then((res) => {
        const secondary_zillow_estimated_value = res.data;
        let range = null;
        let secondary_home_market_value = "";
        for (let i = 0, len = rangeValues.length; i < len; i++) {
          range = F.rangeToArray(rangeValues[i]);
          if (
            secondary_zillow_estimated_value >= range[0] &&
            secondary_zillow_estimated_value <= range[1]
          ) {
            secondary_home_market_value = rangeValues[i];
          }
        }
        if (secondary_zillow_estimated_value > 1000000) {
          secondary_home_market_value = "$900,001-$1,000,000";
        }

        updateField(
          "secondary_zillow_estimated_value",
          secondary_zillow_estimated_value
        );
        updateField("secondary_home_market_value", secondary_home_market_value);
        this.setState({ zillow_loading: false });
      });
    }
  };
  handleSearch = (query) => {
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      axios
        .post("/api/zestimate-suggestions", {
          address: query
        })
        .then((res) => {
          F.log("Rsponse >", res.data);
          const dataSource = [];
          const addresses = {};
          let zpid = null;
          if (res.data.results) {
            if (res.data.results.length) {
              F.log("res.data.results = > ", res.data.results);
              for (var j = 0; j < res.data.results.length; j++) {
                const address = res.data.results[j];
                if (address.resultType === "Address") {
                  dataSource.push(address.display);
                  if (!zpid) {
                    zpid = address.metaData.zpid;
                  }

                  var addr = [];
                  if (typeof address.metaData.streetNumber !== "undefined") {
                    addr.push(address.metaData.streetNumber);
                  }
                  if (typeof address.metaData.streetName !== "undefined") {
                    addr.push(address.metaData.streetName);
                  }
                  if (address.length > 0) {
                    addr = addr.join(" ");
                  } else {
                    addr = address.display.split(",")[0];
                  }

                  addresses[address.display] = {
                    address: addr,
                    secondary_zillow_address: address.display,
                    city: address.metaData.city,
                    state: address.metaData.state,
                    postal_code: address.metaData.zipCode,
                    country: address.metaData.country,
                    zpid: address.metaData.zpid
                  };
                }
              }
              this.setState({ dataSource, addresses, zpid });
            }
          } else {
            F.log("ERROR");
          }
        });
    }, 1000);
  };
  selectAddress(val) {
    const { addresses } = this.state;
    const { updateField } = this.props;

    if (val in addresses) {
      const address = addresses[val];

      // updateField("address", address.address);
      // updateField("city", address.city);
      // updateField("state", address.state);
      // updateField("zipcode", address.postal_code);
      updateField("secondary_zillow_address", address.secondary_zillow_address);
      // updateField(
      //   "secondary_zillow_address_cont",
      //   address.city + " " + address.state + " " + address.postal_code
      // );

      // if ("setAddress" in this.props) {
      //   updateField("address", address.address);
      // }
      // if ("setCity" in this.props) {
      //   updateField("city", address.city);
      // }
      // if ("setState" in this.props) {
      //   updateField("state", address.state);
      // }
      // if ("setZipCode" in this.props) {
      //   updateField("zipcode", address.postal_code);
      // }
      // if ("setCityStateZip" in this.props) {
      //   updateField(
      //     "secondary_zillow_address_cont",
      //     address.city + " " + address.state + " " + address.postal_code
      //   );
      // }

      this.setState({ zpid: address.zpid });
    }
  }

  render() {
    const { wizard, updateField, updateRadioBtnToggle } = this.props;
    const { zillow_loading, dataSource } = this.state;

    const marks = F.getMarksRangeValues_10M();

    let secondary_home_market_value = 0;
    if (wizard.secondary_home_market_value !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.secondary_home_market_value) {
          secondary_home_market_value = parseInt(x, 10);
        }
      }
    }

    return (
      <div style={{ marginTop: 20 }} >
        <h5 className="headingText">
          "What is the estimated market value of all selected secondary properties (sale price) ?" <span className='asteriskIcon'>*</span>
        </h5>
        <SliderLayout
          marks={marks}
          name="secondary_home_market_value"
          value={secondary_home_market_value}
          updateField={updateField}
          updateRadioBtnToggle={updateRadioBtnToggle}
        />
        <div className="sliderValue center-align silder-align">
          {wizard.secondary_home_market_value || "$0"}
        </div>
      </div>
    );
  }
}

export default ZillowSecondaryHomeValueContainer;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/zillow-secondary-home-value-container_updated.js